/*
 * user Actions
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 04-Jul-2024
 */

import { createRequestTypes, createAction, MakeRequest } from './index'

export const actionTypes = {
  DO_FETCH_TERMINAL_ID_LIST: '@@user/fetch_terminal_id_list',
  DO_GET_USER_PROFILE: '@@user/get_user_profile',
  DO_GET_SUBSCRIPTION_GLOBAL: '@@user/get_subscription_global',
  DO_SET_MERCHANT_SEARCH: '@@user/set_merchant_search',
  DO_SET_SWITCHABLE_MERCHANTS: '@@user/set_switchable_merchants',
  DO_LOGOUT: '@@user/logout',
  DO_POST_SUBSCRIPTION_GLOBAL: '@@user/post_subscription_global',
  // @generator action:type
  ...createRequestTypes('@@user', 'GET_TERMINAL_ID_LIST'),
  ...createRequestTypes('@@user', 'RETRIVE_USER_PROFILE'),
  ...createRequestTypes('@@user', 'RETRIEVE_SUBSCRIPTION_GLOBAL'),
  ...createRequestTypes('@@user', 'POST_SUBSCRIPTION_GLOBAL'),
  // @generator action:type:request
}

// ------------------------------------
// Actions
// ------------------------------------

// @generator action:request
/** @action request
 * * Insert a description
 * @name retriveUserProfile
 * @return {object} - The action object
 */
export const retriveUserProfile = new MakeRequest('user', 'retrive_user_profile')
/** @action request
 * * Insert a description
 * @name getTerminalIdList
 * @return {object} - The action object
 */
export const getTerminalIdList = new MakeRequest('user', 'get_terminal_id_list')

/** @action request
 * * Insert a description
 * @name retriveSubscriptionGlobal
 * @return {object} - The action object
 */
export const retrieveSubscriptionGlobal = new MakeRequest('user', 'retrieve_subscription_global')
/** @action request
 * * Insert a description
 * @name postSubscriptionGlobal
 * @return {object} - The action object
 */
export const postSubscriptionGlobal = new MakeRequest('user', 'post_subscription_global')
// @generator action
/** @action
* * Insert a description
* @name Logout
* @return {object} - The payload object
*/
export const doLogout = payload => createAction(actionTypes.DO_LOGOUT, { payload });
/** @action
 * * Insert a description
 * @name SetMerchantSearch
 * @return {object} - The payload object
 */
export const doSetMerchantSearch = (payload) => createAction(actionTypes.DO_SET_MERCHANT_SEARCH, { payload })
export const doSetSwitchableMerchants = (payload) =>
  createAction(actionTypes.DO_SET_SWITCHABLE_MERCHANTS, { payload })
/** @action
 * * Insert a description
 * @name GetUserProfile
 * @return {object} - The payload object
 */
export const doGetUserProfile = (payload) => createAction(actionTypes.DO_GET_USER_PROFILE, { payload })
/** @action
 * * Insert a description
 * @name GetSubscriptionGlobal
 * @return {object} - The payload object
 */
export const doGetSubscriptionGlobal = (payload) =>
  createAction(actionTypes.DO_GET_SUBSCRIPTION_GLOBAL, { payload })
/** @action
 * * Insert a description
 * @name FetchTerminalIdList
 * @return {object} - The payload object
 */
export const doFetchTerminalIdList = (payload) => createAction(actionTypes.DO_FETCH_TERMINAL_ID_LIST, { payload })

/** @action
 * * Insert a description
 * @name PostSubscriptionGlobal
 * @return {object} - The payload object
 */
export const doPostSubscriptionGlobal = (payload) => createAction(actionTypes.DO_POST_SUBSCRIPTION_GLOBAL, { payload })
